import {getField, updateField} from 'vuex-map-fields';

export default {
    modules: {
        brandComponentProviderComponent: {
            namespaced: true,
            state: {
                providerComponentList: [],
                loading: false,
                options: {
                    page: 1,
                    itemsPerPage: 50,
                    sortBy: ['part_number'],
                    sortDesc: [false],
                    multiSort: false,
                    mustSort: true,
                    descending: false,
                },
                totalRecords: 0,
                selectedItemList: [],
                searchTerm: null,
                availableInStock: false,
            },
            actions: {
                async fetchProviderComponent(ctx, brandComponentID) {
                    ctx.commit('updateLoading', true)
                    const requestParams = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                        },
                    };
                    let url = "/api/provider_component/?page=" + ctx.state.options.page + '&page_size=' + ctx.state.options.itemsPerPage
                    if (ctx.state.options.sortDesc[0])
                        url += '&order_by=-' + ctx.state.options.sortBy[0]
                    else
                        url += '&order_by=' + ctx.state.options.sortBy[0]
                    if (brandComponentID != null)
                        url += "&brand_component_id=" + brandComponentID
                    if (ctx.state.searchTerm != null)
                        url += "&search_term=" + ctx.state.searchTerm
                    if (ctx.state.availableInStock == true)
                        url += "&only_in_stock"
                    const res = await fetch(url, requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateLoading', false)
                        return
                    }
                    const result = await res.json()
                    // console.log('fetchProviderComponent', result)
                    // console.log('fetchProviderComponent', ctx.state.options)
                    ctx.commit('updateProviderComponent', result.results)
                    ctx.commit('updateTotalRecords', result.count)
                    ctx.commit('updateLoading', false)
                },
                async fetchDeleteSelected(ctx) {},
                async fetchUpdateSelected(ctx) {},
                async fetchAddItem(ctx, brandComponentId) {},
                async fetchEditItem(ctx, brandComponentId) {},
            },

            mutations: {
                updateField,
                updateProviderComponent(state, providerComponentList) {
                    state.providerComponentList = providerComponentList
                },
                updateLoading(state, loading) {
                    state.loading = loading
                },
                updateTotalRecords(state, totalRecords) {
                    state.totalRecords = totalRecords
                },
            },
            getters: {
                getField,
                getProviderComponentList(state) {
                    return state.providerComponentList
                },
                getLoading(state) {
                    return state.loading
                },
            },
        }
    }
}